/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from 'moment';
// Date Fns is used to format the dates we receive
// from our API call
// import { format } from "date-fns";
import Logo from '../assets/UW_Horizontal_Logo_Full.png'

// define a generatePDF function that accepts a tickets argument
const generatePDF = (sessionList, paymentInformation) => {
    // initialize jsPDF
    const doc = new jsPDF({
        orientation: "l"
    });

    // define the columns we want and their titles
    const tableColumn = ["Sr no.", "Booked on", "Mode", "Report", "Coupon", "Voucher", "Paid by Client"/*, "Platform Charges"*/, "Amount Earned", "Transaction Id"];
    // define an empty array of rows
    let totals = { couponAmount: 0, voucherAmount: 0, paidByClient: 0, /*platformCharges: 0,*/ amountEarned: 0 };
    let tableRows = [];
    Promise.all(
        sessionList.map((item, index) => {
            totals.couponAmount += item.couponAmount;
            totals.voucherAmount += item.voucherAmount;
            totals.paidByClient += item.amountWOTax;
            // totals.platformCharges += item.platformCharges;
            totals.amountEarned += item.amountEarned;
            return [
                index + 1,
                moment(item.createdAt).format("DD-MM-YYYY hh:mm A"),
                item.modeOfServiceSelected,
                item.isReportIncluded ? item.isReportIncluded.status ? `Yes for Rs.${item.isReportIncluded.amount}` : "No" : "No",
                "Rs. " + item.couponAmount.toFixed(2),
                "Rs. " + item.voucherAmount.toFixed(2),
                "Rs. " + item.amountWOTax.toFixed(2),
                // "Rs. " + item.platformCharges.toFixed(2) + " (" + paymentInformation.platformChargesPercentage + "%)",
                "Rs. " + item.amountEarned.toFixed(2),
                item.paymentId.payment.razorpay_payment_id
                // called date-fns to format the date on the session
                // format(new Date(session.updated_at), "yyyy-MM-dd")
            ];
        })
    ).then(data => {
        tableRows = data;
        tableRows.push([
            { content: 'Total', colSpan: 4, styles: { halign: 'center', fontStyle: 'bold' } },
            { content: "Rs. " + totals.couponAmount.toFixed(2), styles: { fontStyle: 'bold' } },
            { content: "Rs. " + totals.voucherAmount.toFixed(2), styles: { fontStyle: 'bold' } },
            { content: "Rs. " + totals.paidByClient.toFixed(2), styles: { fontStyle: 'bold' } },
            // { content: "Rs. " + totals.platformCharges.toFixed(2), styles: { fontStyle: 'bold' } },
            { content: "Rs. " + totals.amountEarned.toFixed(2), styles: { fontStyle: 'bold' } },
            ""]);

        // startY is basically margin-top
        doc.addImage(Logo, 'PNG', 5, 4, 32, 15);
        doc.text(`Payment report from ${paymentInformation.fromDate} to ${paymentInformation.toDate}`, 40, 13);
        doc.autoTable(tableColumn, tableRows, { startX: 5, startY: 22 });
        // const date = Date().split(" ");
        // we use a date string to generate our filename.
        // const dateStr = date[0] + date[1] + date[2] + date[3] + date[4];
        // session title. and margin-top + margin-left
        // we define the name of our PDF file.
        // window.open(URL.createObjectURL(doc.output("blob")));
        doc.save(`report_${paymentInformation.fromDate}.pdf`);
    })
};

export default generatePDF;